import { useNavigate } from "react-router-dom";
import styles from "./PrivacyPolicy.module.scss";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import { useEffect } from "react";

const PrivacyPolicy: React.FC = () => {
  const redirect = useNavigate();
  const path = window.location.pathname;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="d-flex flex-column align-items-center justify-content-center col-12">
        <div className={`${styles.firstDiv} col-12 `}>
          <Header />
          <div className="d-md-flex   flex-column align-items-center  justify-content-center col-12  p-7">
            <div className="d-flex flex-row align-items-center justify-content-center color-white small-title">
              Privacy Policy
            </div>

            <div className="d-flex flex-column align-items-center justify-content-center col-md-8 col-12  mt-7 color-white text">
              <span className="d-flex flex-row col-12 align-items-center justify-content-center">
                INFORMATIVA PRIVACY AI SENSI DEGLI ARTT. 13-14 DEL REGOLAMENTO
                EUROPEO "PRIVACY" (GDPR)
              </span>
              <span className="d-flex flex-row col-12 mt-4 justify-content-center text-center ">
                INFORMATIVA PER IL TRATTAMENTO DI DATI PERSONALI
              </span>
              <span className="d-flex flex-row col-12 mt-5 ">
                In questa pagina si descrivono le modalità di gestione del sito
                in riferimento al trattamento dei dati personali degli utenti
                che lo consultano, nonché modalità e finalità di trattamento dei
                dati personali.
              </span>
              <span className="d-flex flex-row col-12 mt-3 ">
                Si tratta di un’informativa resa ai sensi dell’art. 13-14 del
                Regolamento UE 2016/679 (GDPR) a coloro che interagiscono con i
                servizi web accessibili per via telematica a partire
                dall’indirizzo del sito web di Mauro Scavazzon.
              </span>
              <span className="d-flex flex-row col-12 mt-3 ">
                Questo sito è di proprietà di Mauro Scavazzon, che gestisce e
                mantiene il sito con lo scopo di fornire informazioni e
                comunicazioni inerenti i prodotti e i servizi offerti.
              </span>
              <span className="d-flex flex-row col-12 mt-3 ">
                L’informativa è resa solo per il sito in oggetto e non anche per
                altri siti web eventualmente consultabili tramite link, di cui
                Mauro Scavazzon non è in alcun modo responsabile.
              </span>
              <span className="d-flex flex-row col-12 mt-3 ">
                Mauro Scavazzon, in qualità di Titolare del trattamento dei Suoi
                dati personali, ai sensi e per gli effetti del Regolamento UE
                2016/679 – GDPR, La informa che il trattamento dei dati
                personali sarà improntato ai principi di correttezza, liceità,
                trasparenza e tutela della Sua riservatezza e dei Suoi diritti.
                I Suoi dati personali verranno trattati in accordo alle
                disposizioni legislative della normativa sopra richiamata e
                degli obblighi di riservatezza previsti.
              </span>
              <span className="d-flex flex-row col-12 mt-5 fw-bold">
                TIPI DI DATI TRATTATI
              </span>
              <span className="d-flex flex-row col-12 mt-3">
                Dati di Navigazione. <br /> I sistemi informatici e le procedure
                software preposte al funzionamento di questo sito web
                acquisiscono, nel corso del loro normale esercizio, alcuni dati
                personali la cui trasmissione è implicita nell’uso dei
                protocolli di comunicazione di Internet.
              </span>
              <span className="d-flex flex-row col-12 mt-3">
                Dati forniti volontariamente dall’utente <br /> L’invio
                facoltativo, esplicito e volontario di posta elettronica agli
                indirizzi indicati su questo sito, così come la compilazione dei
                form per l’invio di richieste specifiche, comportano la
                successiva acquisizione dell’indirizzo del mittente e degli
                eventuali altri dati personali inseriti.
              </span>
              <span className="d-flex flex-row col-12 mt-3">
                Dati di profilo e di acquisto <br /> Qualora previsto, al
                momento della registrazione o dell’ordine, possono essere
                raccolti dati personali quali nome, cognome, data di nascita,
                email, dati di contatto e dettagli relativi agli acquisti
                effettuati.
              </span>
              <span className="d-flex flex-row col-12 mt-3">
                Dati di profilo e di acquisto <br /> Qualora previsto, al
                momento della registrazione o dell’ordine, possono essere
                raccolti dati personali quali nome, cognome, data di nascita,
                email, dati di contatto e dettagli relativi agli acquisti
                effettuati.
              </span>
              <span className="d-flex flex-row col-12 mt-5 fw-bold">
                MODALITÀ DEL TRATTAMENTO
              </span>
              <span className="d-flex flex-row col-12 mt-3 ">
                I dati sono trattati con strumenti elettronici e informatici,
                adottando misure di sicurezza idonee per prevenirne la perdita,
                usi illeciti o non corretti e accessi non autorizzati.
              </span>
              <span className="d-flex flex-row col-12 mt-5 fw-bold">
                FINALITÀ DEL TRATTAMENTO
              </span>
              <span className="d-flex flex-row col-12 mt-3 ">
                Il trattamento dei dati verrà effettuato per le seguenti
                finalità: <br /> - Consentire la navigazione del sito;
                <br /> - Fornire informazioni sui servizi e prodotti offerti;
                <br /> - Eseguire gli obblighi previsti da leggi o regolamenti;
                <br /> - Monitorare l’efficacia del servizio offerto.
              </span>
              <span className="d-flex flex-row col-12 mt-5 fw-bold">
                SOGGETTI A CUI POTRANNO ESSERE COMUNICATI I DATI PERSONALI
              </span>
              <span className="d-flex flex-row col-12 mt-3 ">
                I dati possono essere comunicati a soggetti autorizzati per la
                gestione dei servizi offerti e non verranno diffusi a terzi.
              </span>
              <span className="d-flex flex-row col-12 mt-5 fw-bold">
                PERIODO DI CONSERVAZIONE DEI DATI
              </span>
              <span className="d-flex flex-row col-12 mt-3 ">
                I dati saranno conservati per il periodo necessario
                all’espletamento dei servizi richiesti e nel rispetto delle
                normative vigenti.
              </span>
              <span className="d-flex flex-row col-12 mt-5 fw-bold">
                DIRITTI DEGLI INTERESSATI
              </span>
              <span className="d-flex flex-row col-12 mt-3 ">
                Gli interessati hanno il diritto di: <br /> - Accedere ai propri
                dati personali;
                <br /> - Chiederne la rettifica o la cancellazione;
                <br /> - Opporsi al trattamento per motivi legittimi;
                <br /> - Proporre reclamo all’Autorità di controllo per la
                protezione dei dati personali.
              </span>
              <span className="d-flex flex-row col-12 mt-5 fw-bold">
                TITOLARE DEL TRATTAMENTO
              </span>
              <span className="d-flex flex-row col-12 mt-3 ">
                Il Titolare del trattamento è Mauro Scavazzon, contattabile
                all’indirizzo email fornito sul sito.
              </span>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default PrivacyPolicy;
